(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aa-sneaker-sizing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aa-size-choice')) {
    customElements.define('aa-size-choice', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        if (!this.root) return;
        this.chosen = false;
        this.onChange = (event) => {
          const field = event.target.closest('[data-aa-size-option]');
          if (!field || !this.root.contains(field)) return;
          if (!event.target.matches('input, select')) return;
          if (!event.target.value) return;
          this.chosen = true;
          this.querySelector('[data-aa-size-prompt]').hidden = true;
          this.root.querySelectorAll('[data-add-to-cart]').forEach((button) => { button.disabled = true; });
        };
        this.onSubmit = (event) => {
          if (this.chosen || !event.target.matches('[data-product-form]')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          const field = this.root.querySelector('[data-aa-size-option]');
          field?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          field?.querySelector('input[type="radio"], [data-popout-toggle], select')?.focus();
        };
        this.root.addEventListener('change', this.onChange, true);
        this.root.addEventListener('submit', this.onSubmit, true);
        this.observer = new MutationObserver(() => this.enforceChoice());
        this.observer.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'checked'] });
        this.enforceChoice();
      }

      enforceChoice() {
        if (this.chosen) return;
        const field = this.root.querySelector('[data-aa-size-option]');
        if (!field) return;
        const prompt = this.dataset.prompt;
        field.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.removeAttribute('checked');
        });
        field.querySelectorAll('[data-popout-input]').forEach((input) => {
          input.value = '';
          input.dataset.optionValueId = '';
        });
        field.querySelectorAll('[aria-current], [selected]').forEach((option) => {
          option.removeAttribute('aria-current');
          option.removeAttribute('selected');
        });
        field.querySelectorAll('[data-selected-value], [data-popout-toggle-text]').forEach((label) => {
          if (label.textContent !== prompt) label.textContent = prompt;
        });
        this.root.querySelectorAll('[data-add-to-cart]').forEach((button) => {
          if (!button.disabled) button.disabled = true;
          const label = button.querySelector('[data-add-to-cart-text]');
          if (label && label.textContent !== prompt) label.textContent = prompt;
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.root?.removeEventListener('change', this.onChange, true);
        this.root?.removeEventListener('submit', this.onSubmit, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
